import { css, theme } from '../lib';

export const baseFont = css`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.regular};
`;

export const baseFontLight = css`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.light};
`;

export const baseFontHeading = css`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.strong};
`;

export const bodyLargeStandard = css`
  font-style: normal;
  font-size: ${theme.fontSizes.lg};
  line-height: 1.5rem;
`;

export const bodyLargeShort = css`
  font-style: normal;
  font-size: ${theme.fontSizes.lg};
  line-height: 1.25rem;
`;

export const bodyMediumStandard = css`
  font-style: normal;
  font-size: ${theme.fontSizes.md};
  line-height: 1.5rem;
`;

export const bodyMediumShort = css`
  font-style: normal;
  font-size: ${theme.fontSizes.md};
  line-height: 1rem;
`;

export const auxiliarSmall = css`
  font-style: normal;
  font-size: ${theme.fontSizes.sm};
  line-height: 1rem;
`;

export const auxiliarMini = css`
  font-style: normal;
  font-size: ${theme.fontSizes.xs};
  line-height: 1rem;
`;

export const overline = css`
  font-style: normal;
  font-size: ${theme.fontSizes.xs};
  letter-spacing: 0.08rem;
  line-height: 1rem;
  text-transform: uppercase;
`;
